import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.m.css";

export const SkeletonLoading = ({ className = "" }) => {
  return (
    <div className={`${styles["card"]} ${className}`}>
      <div className={`${styles["card__image"]} ${styles["loading"]}`} />
      <div>
        <div className={`${styles["card__title"]} ${styles["loading"]}`} />
        <div className={`${styles["card__description"]} ${styles["loading"]}`} />
        <div className={`${styles["card__description"]} ${styles["loading"]}`} />
        <div
          className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${styles["loading"]}`}
        />
        <div
          className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${styles["loading"]}`}
        />
        <div
          className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${styles["loading"]}`}
        />
        <div
          className={`${styles["card__description"]} ${styles["card__description__only-mbl"]} ${styles["loading"]}`}
        />
      </div>
    </div>
  );
};

SkeletonLoading.propTypes = {
  className: PropTypes.string
};

export default SkeletonLoading;
